import React from 'react';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { GlobalProvider } from './src/context/GlobalContext';

import $ from 'jquery';
if (typeof window !== 'undefined') {
  window.$ = $;
  window.jQuery = $;
}

Amplify.configure(awsconfig);

import './src/styles/global.css';
import './src/styles/directory.css';

export const wrapRootElement = ({ element }) => (
  <GlobalProvider>{element}</GlobalProvider>
);